import {
  type FormLabelProps as ChakraFormLabelProps,
  FormLabel as ChakraFormLabel,
  forwardRef,
  Flex,
} from "@chakra-ui/react";
import { useMemo, useContext } from "react";
import { injectTypographyVariant } from "@/components/essentials/typography/variant";
import { type TypographyProps } from "@/components/essentials/typography";
import { FormControlContext } from "./context";
import { Tag } from "@/components/essentials/tag";
import { css } from "@emotion/react";
import { chakraFormLabelTestId, formLabelTestId, tagTestId } from "./const";

export interface FormLabelProps extends Omit<ChakraFormLabelProps, "typography"> {
  readonly typography?: TypographyProps["variant"];
}

export const FormLabel = forwardRef<FormLabelProps, "div">(
  ({ typography = "display6", children, ...rest }: FormLabelProps, ref) => {
    const variantProps = useMemo(() => injectTypographyVariant(typography), [typography]);
    const { isRequired } = useContext(FormControlContext);
    return (
      <Flex alignItems="center" data-testid={formLabelTestId}>
        <ChakraFormLabel
          ref={ref}
          data-testid={chakraFormLabelTestId}
          {...variantProps}
          {...rest}
          css={css`
            & > span {
              display: none;
            }
          `}
        >
          {children}
        </ChakraFormLabel>
        {isRequired && (
          <Tag
            typography="display8"
            size="sm"
            mb="0.5rem"
            colorScheme="primary"
            variant="solid"
            data-testid={tagTestId}
          >
            必須
          </Tag>
        )}
      </Flex>
    );
  },
);
